import { render } from "./McpAppRenderer.vue?vue&type=template&id=2c05079b&scoped=true"
import script from "./McpAppRenderer.vue?vue&type=script&lang=js"
export * from "./McpAppRenderer.vue?vue&type=script&lang=js"

import "./McpAppRenderer.vue?vue&type=style&index=0&id=2c05079b&scoped=true&lang=css"
import "./McpAppRenderer.vue?vue&type=style&index=1&id=2c05079b&lang=scss"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c05079b"]])

export default __exports__